import { render, staticRenderFns } from "./IssueTracker.vue?vue&type=template&id=24c43e75&scoped=true&"
import script from "./IssueTracker.vue?vue&type=script&lang=js&"
export * from "./IssueTracker.vue?vue&type=script&lang=js&"
import style0 from "./IssueTracker.vue?vue&type=style&index=0&id=24c43e75&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c43e75",
  null
  
)

export default component.exports